<template>
    <base-modal
        size="lg"
        hide-header
        hide-footer
        @close="$emit('close')"
    >
        <div class="editor-form">
            <h2 class="editor-header">
                {{ sewerItemUpdate.id > 0 || sewerItems.length === 1 ? $t('storm_sewers.edit_item') : sewerItems && sewerItems.length > 1 ? $t('storm_sewers.edit_items') : $t('storm_sewers.add_to_system') }}
            </h2>
            <div class="col-sm-12 form-data nopads">
                <!-- Show open contracts -->
                <div class="col-12 nopads">
                    <span class="span-title">{{ $t('orders.contract') }}</span>
                    <select
                        id="contract"
                        v-model="sewerItemUpdate.contract.id"
                        class="form-select form-select-sm sm-3"
                        :disabled="sewerItemUpdate.remove === '1'"
                    >
                        <option :value="null">
                            {{ $t('orders.select_contract') }}
                        </option>
                        <option
                            v-for="option in contracts"
                            :key="option.id"
                            :value="option.id"
                        >
                            {{ option.name }}
                        </option>
                    </select>
                </div>

                <div class="col-12 nopads">
                    <span class="span-title">{{ $t('storm_sewers.status') }}</span>
                    <select
                        id="status"
                        v-model="sewerItemUpdate.status"
                        class="form-select form-select-sm sm-3"
                        :disabled="sewerItemUpdate.remove === '1'"
                    >
                        <option :value="null">
                            {{ $t('storm_sewers.select_status') }}
                        </option>
                        <option
                            v-for="option in getStatusOptions()"
                            :key="option.value"
                            :value="option.value"
                        >
                            {{ option.text }}
                        </option>
                    </select>
                </div>

                <div class="col-12 nopads">
                    <span class="span-title">{{ $t('storm_sewers.radius') }}</span>
                    <input
                        id="radius"
                        v-model="sewerItemUpdate.radius"
                        type="number"
                        step="any"
                        min="0"
                        class="form-control form-control-sm"
                    >
                </div>

                <div class="col-12 nopads">
                    <span class="span-title">{{ $t('storm_sewers.material') }}</span>
                    <select
                        id="material"
                        v-model="sewerItemUpdate.material"
                        class="form-select form-select-sm sm-3"
                    >
                        <option :value="null">
                            {{ $t('road_sign.select_material') }}
                        </option>
                        <option
                            v-for="item in getMaterialOptions()"
                            :key="item.value"
                            :value="item.value"
                        >
                            {{ item.text }}
                        </option>
                    </select>
                </div>

                <div class="col-sm-12 button-container">
                    <button
                        class="btn btn-secondary form-button"
                        @click.stop="$emit('close')"
                    >
                        {{ $t('common.cancel') }}
                    </button>
                    <button
                        class="btn btn-success form-button"
                        :disabled="loading"
                        @click.stop="submitMultiple"
                    >
                        {{ $t('common.save') }}
                    </button>
                </div>
            </div>
            <div
                v-if="loading"
                id="loader"
                class="spinner"
            />
        </div>
    </base-modal>
</template>

<script>
import {restApi} from "../mixins/RestApiMixin";
import {attachmentHelper} from "../mixins/AttachmentMixin";
import {workAssignmentHelper} from "../mixins/WorkAssignmentMixin";
import {roadSignHelper} from "@/components/mixins/RoadSignMixin";
import {mapHelper} from "@/components/mixins/MapMixin";
import {stormSewersMixin} from "@/components/mixins/StormSewersMixin";
import {timeUtils} from "../mixins/TimeUtils";
import BaseModal from "@/components/BaseModal";
import {inject} from "vue";

export default {
    name: "SewerItemBulkEditorDialog",
    components: {BaseModal},
    mixins: [workAssignmentHelper, restApi, timeUtils, attachmentHelper, mapHelper, roadSignHelper, stormSewersMixin],
    props: {
        sewerItems: null,
        isObserver: Boolean,
        updateSewerLines: {
            type: Boolean,
            default: false
        },
        updateSewerDrains: {
            type: Boolean,
            default: false
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function (){
        return{
            sewerItemUpdate: this.newSewerItemMultiple(),
            contracts: [],
            loading: false,
        }
    },
    computed: {
        louhiState() {

            let all = false;
            let none = false;

            all = this.sewerItems.every(r => r.external_system === 2);
                none = this.sewerItems.every(r => !r.external_system || r.external_system !== 2);

            if (all) return 'all';
            if (none) return 'none';
            return 'mixed';
        }
    },
    mounted: function() {
        if(this.louhiState === 'none') {
            this.fetchOpenContracts()
        } else if (this.louhiState === 'all') {
            this.fetchLouhiContracts()
        }
    },
    methods: {
        newSewerItemMultiple: function (like) {
            return {
                contract: like && like.contract ? like.contract : {id: null},
                status: like && like.status ? like.status : null,
                radius: like && like.radius ? like.radius : null,
                material: like && like.material ? like.material : null,
                remove: like && like.remove ? true : undefined,
                ...like
            }
        },
        submitMultiple:function (){
            let newSewerItem = this.setDefaultValues(this.sewerItemUpdate)
            if (newSewerItem) {
                this.loading = true
                if(!this.sewerItems) this.fail
                var sewerLineIds = []
                var sewerDrainIds = []
                this.sewerItems.forEach((sewerItem) => {
                    if(sewerItem.type === this.SEWERS) {
                        sewerLineIds.push(sewerItem.id)
                    } else if(sewerItem.type === this.DRAINS) {
                        sewerDrainIds.push(sewerItem.id)
                    }
                })
                let params = {
                    update_item: {}
                }
                if(newSewerItem.contract) {
                    params.update_item.contract = newSewerItem.contract
                }
                if(newSewerItem.status) {
                    params.update_item.status = newSewerItem.status
                }
                if(newSewerItem.radius) {
                    params.update_item.radius = newSewerItem.radius
                }
                if(newSewerItem.material) {
                    params.update_item.material = newSewerItem.material
                }
                if(this.updateSewerLines) {
                    params.sewer_line_ids = sewerLineIds
                }
                if(this.updateSewerDrains) {
                    params.sewer_drain_ids = sewerDrainIds
                }
                this.restUpdate(this.stormSewerItems , params, this.success, this.fail)
            }
        },
        success: function () {
            this.loading = false
            this.$emit('closeAndUpdate')
        },
        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },
        setDefaultValues: function (sewerItem) {
            sewerItem = JSON.parse(JSON.stringify(sewerItem))
            if (sewerItem.contract && sewerItem.contract.id) {
                sewerItem.contract = sewerItem.contract.id
            } else {
                sewerItem.contract = undefined
            }
            if (!sewerItem.status) {
                sewerItem.status = undefined
            }
            if (!sewerItem.radius) {
                sewerItem.radius = undefined
            }
            if (!sewerItem.material) {
                sewerItem.material = undefined
            }
            if (sewerItem.remove) {
                sewerItem.remove = true
            } else {
                sewerItem.remove = undefined
            }
            return sewerItem
        },
        fetchLouhiContracts: function () {
            this.loading = true
            this.contracts = []
            let now = new Date()
            var params = {}
            params.startDate = now.toISOString()
            params.showOnlyLouhiContracts = 1
            this.restFetchParams(this.contractOpenUrl,
                params,
                this.handleContracts)
        },
        handleContracts: function (results) {
            this.loading = false
            if (results.data) {
                this.contracts = results.data
            }
        },
    }
}
</script>

<style scoped>

</style>
